<template>
	<div class="mapping">
		<div class="mapping__list">
			<span class="mapping__list-name">
				<router-link to="/brand/category/list" class="link"
					>브랜드 카테고리 관리</router-link
				>
			</span>
			<span class="mapping__list-name mapping__name">
				{{ brandCategory.brandCategoryText }}
			</span>
		</div>
		<form @submit.prevent="mappingCategory">
			<table class="simple-table">
				<thead>
					<tr>
						<th>브랜드 카테고리명</th>
						<th>브랜드</th>
						<th>정렬순서</th>
						<th>등록</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							{{ brandCategory.brandCategoryText }}
						</td>
						<td>
							<SearchBrand
								ref="searchBrand"
								@change="setBrand($event)"
							/>
						</td>
						<td>
							<input
								type="number"
								class="input-text"
								placeholder="정렬순서"
								v-model="sortKey"
								@input="checkSortKey"
							/>
						</td>
						<td>
							<button class="btn blue" type="submit">등록</button>
						</td>
					</tr>
				</tbody>
			</table>
		</form>
	</div>
</template>
<script>
	import SearchBrand from '../../components/SearchBrand.vue';
	import { mapState } from 'vuex';

	export default {
		components: {
			SearchBrand,
		},
		data() {
			return {
				brandCategory: '',
				sortKey: '',
				idBrand: 0,
			};
		},
		computed: {
			...mapState({
				selectedBrandCategory: state =>
					state.brandCategory.selectedBrandCategory,
			}),
		},
		created() {
			if (!this.selectedBrandCategory) {
				this.findBrand();
			} else {
				this.brandCategory = this.selectedBrandCategory;
			}
		},
		methods: {
			async mappingCategory() {
				try {
					const id = Number(this.$route.params.idBrand);
					const params = {
						idBrand: this.idBrand,
						sortKey: this.sortKey,
					};
					if (!this.idBrand) {
						alert('브랜드를 선택해주세요.');
						return;
					}
					if (!this.sortKey || this.sortKey === 0) {
						alert('정렬순서를 입력해주세요.');
						return;
					}
					await this.$axiosAdmin2.post(
						`/api/brands/category-mapping/${id}`,
						params
					);
					alert('등록되었습니다.');
					this.$emit('getList');
					this.sortKey = '';
					this.$refs.searchBrand.init();
				} catch (error) {
					alert(
						'등록에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
					console.error(error);
				}
			},
			checkSortKey() {
				if (this.sortKey < 0) {
					this.sortKey = 0;
				}
			},
			async findBrand() {
				try {
					const id = Number(this.$route.params.idBrand);
					const { data } = await this.$axiosAdmin2.get(
						'/api/brands/category'
					);
					this.brandCategory = data.find(
						category => category.idBrandCategory === id
					);
				} catch (error) {
					console.error(error);
				}
			},
			setBrand(event) {
				this.idBrand = event.idBrand;
			},
		},
	};
</script>
<style lang="scss" scoped>
	.mapping {
		&__list {
			width: 30%;
			background: #f5f5f5;
			border-radius: 8px;
			padding: 10px 20px;
			font-size: 15px;
			margin-bottom: 20px;
		}

		&___list-name {
			display: inline-block;
			margin-right: 10px;
		}

		&__name {
			&::before {
				content: '/';
				margin: 0 10px;
			}
		}

		margin-top: 30px;
		padding: 0 50px;
		.simple-table {
			th {
				background: linear-gradient(to top, #d3e1f1, #f4f7fa, #f4f7fa);
				border: solid 1px #d5dde6;
				text-align: center;
				padding: 0;
			}
			td {
				text-align: center;
			}
		}
	}
</style>
